import PropTypes from "prop-types";
import React from "react";

const LastNameField = ({lastName, changeHandler}) => (
  <label className="lastName">
    Last Name*
    <br />
    <input
      className="last-name-field"
      data-recurly="last_name"
      id="lastName"
      name="lastName"
      onChange={changeHandler}
      type="text"
      value={lastName}
    />
  </label>
);

LastNameField.propTypes = {
  "changeHandler": PropTypes.func.isRequired,
  "lastName": PropTypes.string.isRequired
};

export default LastNameField;
